'use strict';

import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_title: 'Preencha matrícula corretamente',
  },
  en: {
    modal_title: 'Please fill out the registration correctly. Six numbers are required.',
  },
  es: {
    modal_title: 'Completar el registro correctamente',
  },
};

const personal = {
  init() {
    $('.form-signin').on('submit', function (e) {
      if ($('[name="enrollment"]').val().length < 6) {
        e.preventDefault();
        Swal.fire('', tr[lang].modal_title, 'error');
      }
    });
  },
};

export default personal;
